import { Facebook, Linkedin, Mail, Twitter } from "lucide-react";
import React from "react";

const footerSections = [
  {
    title: "À propos",
    links: [
      { name: "Qui sommes-nous", href: "/about" },
      { name: "Carrières", href: "#" },
      { name: "Blog", href: "#" },
      { name: "Presse", href: "#" },
    ],
  },
  {
    title: "Support",
    links: [
      { name: "FAQ", href: "#" },
      { name: "Contact", href: "#" },
      { name: "Documentation", href: "#" },
      { name: "Status", href: "#" },
    ],
  },
  {
    title: "Légal",
    links: [
      { name: "CGU", href: "#" },
      { name: "Politique de confidentialité", href: "#" },
      { name: "Cookies", href: "#" },
      { name: "RGPD", href: "#" },
    ],
  },
];

const socialLinks = [
  { icon: Facebook, href: "#", label: "Facebook" },
  { icon: Twitter, href: "#", label: "Twitter" },
  { icon: Linkedin, href: "#", label: "LinkedIn" },
  { icon: Mail, href: "#", label: "Email" },
];

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and description */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold text-white mb-4">Docuveritas</h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              La référence en matière d'information juridique professionnelle.
              Recherche, IA et certification par des experts.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="text-slate-400 hover:text-slate-300 transition-colors"
                  aria-label={social.label}
                >
                  <social.icon className="h-6 w-6" />
                </a>
              ))}
            </div>
          </div>

          {/* Footer sections */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h4 className="text-lg font-semibold text-white mb-4">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-slate-300 transition-colors"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 Docuveritas. Tous droits réservés.
            </p>
            <p className="text-gray-400 text-sm mt-4 md:mt-0">
              Fait avec ❤️ pour les professionnels du droit
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
